import { defineRecipe } from '@chakra-ui/react';

export default defineRecipe({});
